module.exports = __webpack_public_path__ + "img/mindjam.0769b5d0.jpg";